import { toQueryString } from ".";
import { RoofType } from "../model/solar-recommendation-form/roofType";
import { apiSlice } from "../stores/base/api-slice";

const roofTypeEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		roofTypes: builder.query<RoofType[], string | null>({
			query: premiseType => ({
				url: `/roof-type` + toQueryString({premiseType}),
				method: "GET",
			}),
			providesTags: ["RoofTypes"],
		}),
		createRoofType: builder.mutation<any, FormData>({
			invalidatesTags: ["RoofTypes"],
			query: formData => ({
				url: "/roof-type",
				method: "POST",
				body: formData,
			}),
		}),
		updateRoofType: builder.mutation<any, FormData>({
			invalidatesTags: ["RoofTypes"],
			query: formData => ({
				url: "/roof-type",
				method: "PUT",
				body: formData,
			}),
		}),
		deleteRoofType: builder.mutation<any, FormData>({
			invalidatesTags: ["RoofTypes"],
			query: formData => ({
				url: "/roof-type",
				method: "DELETE",
				body: formData,
			}),
		}),
	}),
});

export const { useLazyRoofTypesQuery, useCreateRoofTypeMutation, useUpdateRoofTypeMutation, useDeleteRoofTypeMutation } = roofTypeEndpoints;
